<template>
  <div>
    <v-container fluid class="d-flex justify-center align-center" style="min-height: 90vh">
      <v-card class="rounded-xl elevation-4 pa-6" max-width="800" width="100%">
        <v-card-title class="justify-center pb-4 text-center">
          <span class="text-h6 font-weight-bold">
            Check In
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-container>
            <v-row dense>
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">Booking Name :</b> {{ BookingName }}</p>
                <p style="font-size: 16px">
                  <b style="color: black">Date/Time :</b> {{ DateTime }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">Room :</b> {{ RoomName }}</p>
                <p style="font-size: 16px">
                  <b style="color: black">HostName :</b> {{ HostName }}</p>
              </v-col>
            </v-row>
            <v-row dense justify="center pt-6">
              <v-col cols="12" md="8" class="d-flex justify-center">
                <v-btn color="green" width="150" class="mr-4 white--text rounded-lg" large>
                  Check In
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card class="pa-6 d-flex flex-column align-center justify-center" elevation="8" rounded="xl">
        <v-progress-circular indeterminate color="indigo" size="70" width="6"></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">Loading, please wait...</span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "CheckinMeeting",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      BookingName: "",
      RoomName: "",
      DateTime: "",
      HostName: "",
      CheckInStatus: "",
    };
  },

  async mounted() {
    let self = this;
    let url = window.location.href;
    if (url != "") {
      let url_text = url.split("/");
      self.getDataMeetingForCheckIn(url_text[url_text.length - 1]);
    }
  },

  methods: {
    getDataMeetingForCheckIn(eventID) {
      let self = this;
      let temp = {
        eventID: eventID,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}Calendar/getDataMeetingForCheckInOffice365ByEventID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BookingName = response.data.data.bookingName;
            self.HostName = response.data.data.hostName;
            self.DateTime = self.ChangeFormatDate(response.data.data.startDate) + " - " + self.ChangeFormatDate(response.data.data.expireDate);
            self.RoomName = response.data.data.roomName;
            self.CheckInStatus = response.data.data.checkinStatus;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped></style>